module.exports = __webpack_public_path__ + "13a98f7374d4b42888e9aa4d80b796c7.png";